import { useEffect, useRef, useState } from "react";
import { FaTrash, FaPlus, FaShare } from "react-icons/fa";
import CircularProgress from '@mui/material/CircularProgress';
import { ModalWrapper } from "./styled"
import { getImgByTour, create, remove } from 'services/imageServices'
import errorImg from 'assets/images/no-image-found.png'
import ShowToast from "utils/ShowToast";

const ModalImageDescription = ({ selectedId, showModalImg, hidden }) => {
    const [dataImage, setDataImage] = useState([])
    const [imgInput, setImgInput] = useState('')
    const imgRef = useRef()
    const imgRefAddImg = useRef()
    const [isLoading, setLoading] = useState(false)
    const [isLoadingRemoveImg, setLoadingRemoveImg] = useState(false)

    useEffect(() => {
        if (selectedId !== null) {
            setLoading(true)
            const api = async () => {
                const res = await getImgByTour(selectedId)
                setDataImage(res.data)
                setLoading(false)

            }
            api()
        }
    }, [selectedId, showModalImg])

    const handleSaveImg = () => {
        const formData = {
            tour_id: selectedId,
            image_path: imgInput
        }
        const api = async () => {
            setLoading(true)
            const res = await create(formData)
            setLoading(false)
            if (res.status === 200) {
                const response = res.data
                if (response.success === true) {
                    setDataImage([response.data, ...dataImage])
                    setImgInput('')
                    ShowToast("success", 'Thêm hình ảnh thành công!')
                }
                else {
                    ShowToast("error", 'Thêm hình ảnh thất bại, vui lòng thử lại sau!')
                }
            } else {
                ShowToast("error", 'Thêm hình ảnh thất bại, vui lòng thử lại sau!')
            }
        }
        if (isLoading === false) {
            api()
        }
    }

    const handleRemoveImage = (id) => {
        const api = async () => {
            setLoadingRemoveImg(true)
            const res = await remove(id)
            setLoadingRemoveImg(false)
            if (res.status === 200) {
                const response = res.data
                if (response.success === true) {
                    setDataImage(
                        dataImage.filter(item => item.id !== id)
                    )
                    ShowToast("success", 'Xóa hình ảnh thành công')
                }
                else {
                    ShowToast("error", 'Xóa hình ảnh thất bại, vui lòng thử lại sau!')
                }
            } else {
                ShowToast("error", 'Xóa hình ảnh thất bại, vui lòng thử lại sau!')
            }
        }
        api()
    }

    const handleErrorImage = () => {
        imgRef.current.src = errorImg
    }

    const handleErrorImageAdd = () => {
        imgRefAddImg.current.src = errorImg
    }

    const handleClose = () => {
        setDataImage([])
        hidden()
    }
    return (
        <ModalWrapper>
            {
                showModalImg &&
                <div className="amid">
                    <div className='amid_overlay'
                        style={
                            showModalImg ? {
                                transform: 'translateY(0%)',
                                opacity: 1
                            } : {
                                transform: 'translateY(-120%)',
                                opacity: 0
                            }
                        }
                        onClick={handleClose}
                    ></div>
                    <div className='amid_container'
                        style={
                            showModalImg ? {
                                transform: 'translateY(0%)',
                                opacity: 1
                            } : {
                                transform: 'translateY(-120%)',
                                opacity: 0
                            }
                        }
                    >

                        <h1 className='amid_header'>Hình ảnh mô tả</h1>

                        <ul className='amid_list'>
                            {
                                dataImage.map(item => (
                                    <li className='amid_item'
                                        key={item.id}
                                    >
                                        <div className='amid_box'>
                                            <img
                                                onError={handleErrorImage}
                                                ref={imgRef}
                                                src={item.image_path || errorImg}
                                                alt='photos' />
                                        </div>
                                        <span className="amid_item_delete"
                                            onClick={() => handleRemoveImage(item.id)}
                                            style={
                                                isLoading ? { cursor: 'not-allowed' } : { cursor: 'pointer' }
                                            }
                                        >
                                            <i><FaTrash /></i>
                                        </span>
                                    </li>
                                ))
                            }
                            {
                                dataImage.length === 0 && imgInput === '' &&
                                <li className='amid_item amid_item_add'>
                                    <div className='amid_box'>
                                        <span>Trống</span>
                                    </div>
                                </li>
                            }
                            {
                                imgInput !== '' &&
                                <li className='amid_item amid_item_add'>
                                    <div className='amid_box'>
                                        <img
                                            onError={handleErrorImageAdd}
                                            ref={imgRefAddImg}
                                            src={imgInput}
                                            alt='photos' />
                                    </div>
                                </li>
                            }
                        </ul>
                        <div className='amid_footer'>
                            <div className="form_input">
                                {
                                    isLoading &&
                                    <div className="loading">
                                        <CircularProgress />
                                    </div>
                                }

                                <input
                                    placeholder="Nhập đường dẫn ảnh"
                                    value={imgInput}
                                    onChange={(e) => setImgInput(e.target.value)}
                                />
                                <button
                                    onClick={handleSaveImg}
                                    style={
                                        isLoadingRemoveImg ? { cursor: 'not-allowed' } : { cursor: 'pointer' }
                                    }
                                >
                                    <i><FaPlus /></i>
                                </button>
                            </div>
                            <button type='button'
                                onClick={handleClose}
                            >
                                <i><FaShare /></i>
                                Thoát
                            </button>
                        </div>
                    </div>
                </div>
            }
        </ModalWrapper>
    );
}

export default ModalImageDescription;